import { GET_OPENNINGS_TO_CONFIG, CHANGE_SETTING_LOCAL, CHANGE_SETTING, CLEAN_STATE } from "./types";

const OpenningManagementReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_OPENNINGS_TO_CONFIG:
            return {
                ...state,
                openningsToConfig: payload.openningsToConfig,
                isFetching: false,
                error: payload.error
            }
        case CLEAN_STATE:
            return {
                ...state,
                openningsToConfig: [],
                isFetching: true,
                error: {
                    ok: false,
                    text: ''
                },
            }
        case CHANGE_SETTING:
            return {
                ...state,
                isFetching: false,
                error: payload.error
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                openningsToConfig: payload,
            }
        default:
            return state;
    }
}

export default OpenningManagementReducer;